import React, { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { NotificationManager } from 'react-notifications';
import { CustomGrid } from '../../../../assets/style/globalStyle';
import { Stack, Typography, Button, Card, Grid, Chip } from '@mui/material';
import { isMobile } from 'react-device-detect';

import configAxios from '../../../../services/configAxios';
import RenderPage from '../../../layouts/RenderPage';
import Iconify from '../../../../@core/theme/Iconify';
import MoreMenu from '../../../components/multiplesComponents/MoreMenu';
import BreadcrumbsNav from '../../../components/multiplesComponents/BreadCrumbs';

import DataGrid, {
  Scrolling,
  Paging,
  HeaderFilter,
  Pager,
  SearchPanel,
  GroupPanel,
  Column,
  ColumnChooser,
  ColumnFixing
} from 'devextreme-react/data-grid';

const allowedPageSizes = [5, 10, 20, 30];

const Competencys = (props) => {
  const [infosCompetencys, setInfosCompetencys] = useState({});

  useEffect(() => {
    getCompetencys();
  }, []);

  function getCompetencys() {
    // const router = infoState.id_type_user === 1 ? `/competency/getCompetencys` : `/competency/getCompetencys?coduser=${infoState.coduser}`;
    const router = '';
    configAxios
      .get(router)
      .then((response) => {
        setInfosCompetencys(response.data);
      })
      .catch(() => {
        NotificationManager.warning(
          'Tivemos dificuldades para buscar as competências, tente novamente!',
          'Atenção'
        );
      });
  }

  function ActionsButtons(items) {
    const infos = [];
    infos.push(items.data.data);
    return infos.map((item) => (
      <MoreMenu
        key={item.id}
        infos={{
          id: item.id,
          router: 'editCompetency',
          functionGrid: getCompetencys,
          otherInfos: item
        }}
      />
    ));
  }

  function ActiveStatus(infos) {
    if (infos.data.data.status === 'Aberta') {
      return <Chip color="warning" size="small" variant="contained" label="Aberta"></Chip>;
    } else if (infos.data.data.status === 'Encerrada') {
      return <Chip color="secondary" size="small" variant="contained" label="Encerrada"></Chip>;
    } else if (infos.data.data.status === 'Aprovada') {
      return <Chip color="success" size="small" variant="contained" label="Aprovada"></Chip>;
    }
  }

  return (
    <RenderPage title="Competências" id="competency">
      <>
        <Stack direction="row" alignItems="center" justifyContent="start" mb={2}>
          <Grid container>
            <BreadcrumbsNav {...props} />
            <Grid item xs={12} sx={{ mt: 2 }}>
              <Typography variant="h4" gutterBottom>
                Lista de competências
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="subtitle2" gutterBottom>
                Utilize as opções abaixo para visualizar as competências cadastradas
              </Typography>
            </Grid>
          </Grid>
          <Stack direction="row" alignItems="center" justifyContent="end" mb={2}>
            <Button
              variant="contained"
              component={RouterLink}
              to="/app/addCompetence"
              startIcon={<Iconify icon="eva:plus-fill" />}>
              Nova
            </Button>
            {/* )} */}
            {!isMobile && (
              <Button
                variant="outlined"
                onClick={getCompetencys}
                sx={{ ml: 1 }}
                startIcon={<Iconify icon="eva:refresh-outline" />}>
                Atualizar
              </Button>
            )}
          </Stack>
        </Stack>
        <Card>
          <CustomGrid>
            <DataGrid
              dataSource={infosCompetencys}
              showBorders={true}
              remoteOperations={true}
              wordWrapEnabled={true}
              allowColumnResizing={true}
              columnAutoWidth={true}
              noDataText={'Não há competências cadastradas'}>
              <Column dataField="id" caption="Id" width={80} />
              <Column dataField="competency" caption="Competência" />
              <Column
                dataField="Status"
                caption="Status"
                width={120}
                cellRender={(data) => <ActiveStatus data={data} />}
              />
              <Column
                dataField="Ações"
                width={100}
                allowSorting={false}
                cellRender={(data) => <ActionsButtons data={data} />}
              />
              <SearchPanel visible={true} width={240} placeholder="Procurar..." />
              {!isMobile && (
                <GroupPanel visible={true} emptyPanelText="Arraste as colunas aqui para agrupar" />
              )}
              <Scrolling rowRenderingMode="virtual"></Scrolling>
              <Paging defaultPageSize={10} />
              <Pager
                visible={true}
                allowedPageSizes={allowedPageSizes}
                showPageSizeSelector={true}
                showInfo={true}
                showNavigationButtons={true}
              />
              <ColumnChooser
                enabled={true}
                title={'Escolher uma coluna'}
                emptyPanelText={'Arraste uma coluna aqui para ocultá-la '}
              />
              <ColumnFixing enabled={true} />
              <HeaderFilter visible={true} allowSearch={true} />
            </DataGrid>
          </CustomGrid>
        </Card>
      </>
    </RenderPage>
  );
};

export default Competencys;
